const register = {
  loginCredentials: "登录信息", // translated
  companyInformation: "公司信息", // translated
  contactDetails: "联系方式", // translated
  businessName: "公司名称", // translated
  businessAddress: "营业地址", // translated
  registrationCode: "注册码", // translated
  businessRegistrationNumber: "营业登记号", // translated
  websiteUrl: "网址", // translated
  mobilePhone: "手机", // translated
  regionStateProvince: "地区/州/省", // translated
  legalTitle: "法定所有权", // translated
  city: "城市", // translated
  postalCode: "邮政编码", // translated
  registrationSuccess: "注册成功。", // translated
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome:
    "请稍等片刻，您将被重定向到主页。", // translated
  usernameEmail: "用户名（电子邮件）", // translated
  password: "密码", // translated
  verifyPassword: "确认密码", // translated
  documents: "文件", // translated
  termsAndConditionsSection: "条款和条件", // translated
  certificateOfIncorporation: "公司注册证书", // translated
  acceptTermsAndConditions: "接受条款和条件", // translated
  country: "国家", // translated
  brandName: "品牌", // translated
  register: "注册", // translated
  isRequired: "为必填项", // translated
  passwordMin8Chars: "必须至少包含 8 个字符", // translated
  passwordRequiresDigit: "必须至少包含 1 个数字", // translated
  passwordRequiresLowercase: "必须至少包含 1 个小写字母", // translated
  passwordRequiresUppercase: "必须至少包含 1 个大写字母", // translated
  passwordRequiresSpecialChar: '至少包含 1 个特殊字符 (!@#$%^&*(),.?":{}|<>)', // translated
  uploadFile: "上传文件", // translated
  filename: "文件名：", // translated
  fileType: "类型：", // translated
  fileSize: "大小：", // translated
  maxFileSize10Mb: "最大：10MB", // translated
  supportedFileTypes: "支持的文件类型：", // translated
  showPassword: "显示密码", // translated
  hidePassword: "隐藏密码", // translated
  notAvailable: "无法使用", // translated
  fileSizeInKb: "{{size}} KB", // translated
  mobilePhonePlaceholder: "例如 +12025550123", // translated
  websiteUrlPlaceholder: "http://www.example.com", // translated
  loading: "加载中...", // translated
  uploadingDocument: "正在上传文件...", // translated
  percentUploaded: "已上传 {{percent}}%", // translated
  registrationSuccessful: "注册成功。", // translated
  failedToUploadDocument: "文件上传失败。", // translated
  fieldIsRequired: "{{field}} {{isRequired}}", // translated
  fieldMinLength: "{{field}}必须超过 {{min}} 个字符", // translated
  fieldMustBeValidEmail: "{{field}}必须是有效的电子邮件", // translated
  fieldPasswordMinLength: "{{field}}必须至少包含 8 个字符", // translated
  fieldPasswordRequiresDigit: "{{field}}必须至少包含 1 个数字", // translated
  fieldPasswordRequiresLowercase: "{{field}}必须至少包含 1 个小写字母", // translated
  fieldPasswordRequiresUppercase: "{{field}}必须至少包含 1 个大写字母", // translated
  fieldPasswordRequiresSpecialChar:
    '{{field}} 至少包含 1 个特殊字符 (!@#$%^&*(),.?":{}|<>)', // translated
  passwordsDoNotMatch: "{{field}}与{{otherField}}不匹配", // translated
  fieldBetweenLength: "{{field}}必须介于 {{min}} 到 {{max}} 个字符之间", // translated
  postalCodeBetweenLength: "{{field}}必须介于 {{min}} 到 {{max}} 个字符之间", // translated
  invalidUrlFormat: "URL 格式无效", // translated
  invalidEmailFormat: "电子邮件格式无效", // translated
  emailMustMatchUsername: "电子邮件必须与用户名（电子邮件）相同", // translated
  mobilePhoneIsRequired: "需要填写手机号码", // translated
  certificateFileTooLarge: "证书文件过大", // translated
  termsMustBeAccepted: "必须接受条款和条件", // translated
};


export default register;
